import { ColumnsType } from "antd/es/table";
import AntTable from "../../components/table/Table";
import {
    EditOutlined,
    DeleteOutlined
} from "@ant-design/icons";
import { Avatar, Button, Flex, Image, Modal, Space, notification } from "antd";
import React, { useState } from "react";
import moment from "moment";
import { Link, useNavigate, useParams } from "react-router-dom";
import CreateConfigReward from "./CreateConfigReward";
import { MemberService } from "../../services/MemberService";
import { CouponService } from "../../services/CouponService";


export default function ConfigReward() {

    const { customer_level_id } = useParams();


    const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
    const [refreshData, setRefreshData] = useState<boolean>(false)
    const [coupons, setCoupons] = useState<Array<any>>([])

    const [columns] = useState<ColumnsType<any>>([
        {
            title: 'Id',
            align: 'center',
            dataIndex: 'id',
            key: 'id',
            render: (value, record) => {
                return value
            },
        },
        {
            title: 'Customer Level Name',
            align: 'center',
            dataIndex: 'customerLevel',
            key: 'customerLevel',
            render: (value, record) => {
                return value?.level_name;
            },
        },
        {
            title: 'Coupon',
            align: 'center',
            dataIndex: 'coupon',
            key: 'coupon',
            render: (value, record) => {
                return value?.name;
            },
        },
        {
            title: 'Total',
            align: 'center',
            dataIndex: 'total',
            key: 'total',
            render: (value, record) => {
                return value;
            },
        },
        {
            title: 'Created At',
            align: 'center',
            dataIndex: 'created_at',
            key: 'created_at',
            render: (value, record) => {
                return moment(value).isValid() ? moment(value).format('DD-MM-YYYY HH:mm') : null;
            },
        },
        {
            title: '',
            align: 'center',
            dataIndex: 'created_at',
            key: 'created_at',
            render: (text, record: any) => {
                return (
                    <Flex gap="small" wrap="wrap">
                        {/* <div onClick={() => {
                            setIsModalOpen(true)
                            setEditRecord(record)
                        }} >
                            <Button type="primary" icon={<EditOutlined></EditOutlined>}></Button>
                        </div> */}
                        <div onClick={() => onDelete(record.id)} >
                            <Button type={'primary'} danger icon={<DeleteOutlined></DeleteOutlined>}></Button>
                        </div>
                    </Flex>
                )
            }
        },

    ])

    React.useEffect(() => {
        getCoupons();
    },[])


    const onLoadData = async (params: any = {}) => {
        const payload = {
            ...params,
            customer_level_id: customer_level_id
        }
        const res = await MemberService.getCustomerLevelReward(payload)
        return res
    }

    const getCoupons = async () => {
        const res = await CouponService.getCoupons({
            page: 1,
            perPage: 500,
            is_public: 1,
            is_expired: 0
        });

        setCoupons(res.data.map((item: any) => {
            return {
                label: item.name,
                value: item.id
            }
        }))
    }



    const onDelete = async (id: number) => {
        const res = await MemberService.deleteCustomerLevelReward(id)

        if (res.status == 1) {
            notification.open({
                type: 'success',
                message: res.status_detail,
                placement: 'top'
            });
            setRefreshData(p => !p)
        } else {
            notification.open({
                type: 'error',
                message: res.status_detail,
                placement: 'top'
            });
        }
    }


    return (
        <>


            <Modal
                title=""
                open={isModalOpen}
                onOk={() => setIsModalOpen(true)}
                onCancel={() => setIsModalOpen(false)}
                footer={null}>
                <CreateConfigReward
                    coupons={coupons}
                    record={{
                        customerLevel: {
                            id: customer_level_id
                        }
                    }}
                    onFinish={() => {
                        setIsModalOpen(false)
                        setRefreshData(p => !p)
                    }}
                ></CreateConfigReward>
            </Modal>
            <AntTable
                refresh={refreshData}
                menuOptions={[{
                    label: 'Add Reward',
                    key: 'create'
                }]}
                menuClick={(e) => {
                    if (e.key == 'create') {
                        setIsModalOpen(true)
                    }

                }}
                search
                title="Customer Level Reward"
                columns={columns}
                onLoadData={onLoadData}
            />

        </>
    )
}
